import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-2--sprite",
  "use": "arrow-2--sprite-usage",
  "viewBox": "0 0 11 8",
  "content": "<symbol viewBox=\"0 0 11 8\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-2--sprite\">\n<path d=\"M1.77333 0L0.833332 0.94L3.88667 4L0.833332 7.06L1.77333 8L5.77333 4L1.77333 0Z\" />\n<path d=\"M6.16667 0L5.22667 0.94L8.28 4L5.22667 7.06L6.16667 8L10.1667 4L6.16667 0Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol